/**
 * Transforms a page name to standardized format: lowercase with hyphens
 * Examples:
 * "My Page Name" -> "my-page-name"
 * "Special Events & Tours" -> "special-events-tours"
 * "Page   With    Spaces" -> "page-with-spaces"
 */
export const standardizePageName = (pageName) => {
  if (!pageName || typeof pageName !== 'string') {
    return ''
  }
  
  return pageName
    .trim()                           // Remove leading/trailing spaces
    .toLowerCase()                    // Convert to lowercase
    .replace(/[^a-z0-9\s-]/g, '')    // Remove special characters except spaces and hyphens
    .replace(/\s+/g, '-')            // Replace multiple spaces with single hyphen
    .replace(/-+/g, '-')             // Replace multiple hyphens with single hyphen
    .replace(/^-|-$/g, '')           // Remove leading/trailing hyphens
}

/**
 * Validates if a page name follows the standard format
 */
export const isValidPageName = (pageName) => {
  if (!pageName || typeof pageName !== 'string') {
    return false
  }
  
  // Check if it matches the pattern: lowercase letters, numbers, hyphens only
  // Must not start or end with hyphen, no consecutive hyphens
  const pattern = /^[a-z0-9]+(-[a-z0-9]+)*$/
  return pattern.test(pageName)
}
